var map = {
	"./en.json": [
		"./pkg/webui/locales/.backend/en.json",
		1238
	],
	"./xx.json": [
		"./pkg/webui/locales/.backend/xx.json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./pkg/webui/locales/.backend lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;